/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { selectMe } from "../../../../../app/modules/Auth/_redux/authRedux";
import { releaseUser } from "../../../../../app/pages/user/userSlice";
import { showErrorDialog } from "../../../../../app/utility";

export function UserProfileDropdown() {
  const { user } = useSelector((state) => state.auth);
  const uiService = useHtmlClassService();
  const dataMe = useSelector(selectMe);
  const dispatch = useDispatch();
  const history = useHistory();

  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);

  const handleLogout = async () => {
    console.log(dataMe.user);
    const params = {
      username: dataMe.username,
    };

    try {
      const response = await dispatch(releaseUser(params));
      if (response.payload.data.status === 200) {
        history.push("/logout");
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div
          className={
            "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
          }
        >
          <span className="symbol symbol-35 symbol-light-warning">
            <span className="symbol-label font-size-h5 font-weight-bold">
              {user.data.username[0]}
            </span>
          </span>
          <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1 ml-2">
            Hi,
          </span>{" "}
          <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
            {user.data.username}
          </span>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <>
          {/** ClassName should be 'dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
          {layoutProps.light && (
            <>
              <div className="d-flex align-items-center p-8 rounded-top">
                <div className="symbol symbol-md bg-light-primary mr-3 flex-shrink-0">
                  <img src={toAbsoluteUrl("/media/users/300_21.jpg")} alt="" />
                </div>
                <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5">
                  {user.data.fullname}
                </div>
                <span className="label label-light-success label-lg font-weight-bold label-inline">
                  3 messages
                </span>
              </div>
              <div className="separator separator-solid"></div>
            </>
          )}

          {!layoutProps.light && (
            <div
              className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
              style={{
                backgroundImage: `url(${toAbsoluteUrl(
                  "/media/misc/bg-3.jpg"
                )})`,
              }}
            >
              <div className="symbol bg-white-o-15 mr-3">
                <span className="symbol-label text-success font-weight-bold font-size-h4">
                  {user.data.username[0]}
                </span>
              </div>
              <div className="text-dark m-0 flex-grow-1 ml-2 mr-3 font-size-h5">
                {user.data.fullname}
              </div>
            </div>
          )}
        </>
        <div className="navi-link">
          <div className="navi navi-spacer-x-0 pt-5 prof">
            <Link to="/user-profile" className="navi-item ">
              <div className="navi-link" style={{ paddingLeft: "1rem" }}>
                <div className="navi-text">
                  <div className="font-weight-bold cursor-pointer ">
                    My Profile
                  </div>
                </div>
              </div>
            </Link>
            <Link to="/change-password" className="navi-item ">
              <div className="navi-link" style={{ paddingLeft: "1rem" }}>
                <div className="navi-text">
                  <div className="font-weight-bold cursor-pointer ">
                    Change Password
                  </div>
                </div>
              </div>
            </Link>
            <Link onClick={handleLogout} className="navi-item ">
              <div className="navi-link" style={{ paddingLeft: "1rem" }}>
                <div className="navi-text">
                  <div className="font-weight-bold cursor-pointer ">Logout</div>
                </div>
              </div>
            </Link>
            {/* <div className="navi-separator mt-3"></div>
            <div className="navi-footer  px-8 py-5 ">
              <Link
                to="/logout"
                className="btn btn-light-primary font-weight-bold"
              >
                Sign Out
              </Link>
            </div> */}
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
